module.exports = __webpack_public_path__ + "static/headspace-cta-6dc0d8ff6c09ba53faf0a3915a29c3c8.png";